import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '../../../components/Page';
import Header from './Header';
import Form from './Form';
import {useParams} from "react-router";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingTop: theme.spacing(3),
		paddingBottom: 100
	}
}));

const SettingFormView = () => {
	const classes = useStyles();

	const {id} = useParams();

	return (
		<Page
			className={classes.root}
			title="Setting"
		>
			<Container maxWidth="lg">
				<Header isNew={false}/>
				<Form />
			</Container>
		</Page>
	);
};

export default SettingFormView;